import { createToast } from "@archery-inc/design-system";
import { loadStripe } from "@stripe/stripe-js";
import { FormattedMessage } from "react-intl";

// js.stripe.com is unreachable behind some networks, blockers and country
// filters. A failed load is a connectivity issue, not a bug, so tell the user
// instead of letting the rejection escape as an unhandled error.
export async function getStripe() {
  try {
    return await loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);
  } catch {
    createToast(<FormattedMessage id="subscribe_error_generic" />, true);
    return null;
  }
}
